import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Modal, Col } from 'react-bootstrap';
import { v4 as uuid } from 'uuid';
import AppContext from 'context/Context';
import { post } from 'services/skill-matric-services/smAreaService';
import SmSectionDropdown from 'components/dropdowns/SkillMatrix/SmSectionDropdown';
import { patch } from 'services/skill-matric-services/smAreaService';

const AreaModal = ({ data, isShow, handleClose, handleSubmit }) => {
  const {
    config: { isDark }
  } = useContext(AppContext);

  useEffect(() => {
    setFormData(data);
  }, [data]);
  const [formData, setFormData] = useState(data);

  const handleDropdown = (field, value) => {
    console.log(field, value);
    const rs = { ...formData, [field]: value.id };
    console.log(rs);
    setFormData({ ...formData, [field]: value.id });
  };

  const handleChange = ({ target }) => {
    let name = target.name;
    let value = target.value;
    setFormData({ ...formData, [name]: value });
  };

  const onSubmit = async e => {
    console.log('submit');
    e.preventDefault();
    console.log(formData);

    if (formData?.id > 0) {
      await patch(formData?.id, { ...formData });
    } else {
      await post({ id: uuid(), ...formData });
    }
    handleSubmit();
  };

  useEffect(() => { }, []);

  return (
    <Modal show={isShow} onHide={handleClose} contentClassName="border">
      <Form onSubmit={onSubmit}>
        <Modal.Header
          closeButton
          closeVariant={isDark ? 'white' : undefined}
          className="bg-light px-card border-bottom-0"
        >
          <Modal.Title as="h5">
            {formData?.id > 0 ? 'Edit' : 'Create'} Area
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-card">
          <Form.Group className="mb-3" controlId="titleInput">
            <Form.Label className="fs-0">Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              required
              value={formData?.name}
              onChange={handleChange}
            />
          </Form.Group>

          <Col md="12">
            <Form.Label className="fs-0">Section</Form.Label>
            <SmSectionDropdown
              fieldName="sectionId"
              isMulti={false}
              selectedOptions={formData?.sectionId}
              handleChange={handleDropdown}
              placeholder="Section"
            />
          </Col>
        </Modal.Body>
        <Modal.Footer className="bg-light px-card border-top-0">
          <Button
            variant="primary"
            type="submit"
            onClick={onsubmit}
            className="px-4 mx-0"
          >
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

AreaModal.propTypes = {
  id: PropTypes.number,
  isShow: PropTypes.bool,
  handleClose: PropTypes.func,
  data: PropTypes.object,
  handleSubmit: PropTypes.func,
  name: PropTypes.string
};

export default AreaModal;
